import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { InputGroup } from '@openng/optimus-ui/inputgroup';
import { InputGroupAddon } from '@openng/optimus-ui/inputgroupaddon';
import { InputNumber } from '@openng/optimus-ui/inputnumber';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface NumberProps extends FieldWrapperProps {
  iconPre?: string;
  iconPost?: string;
  maxFractionDigits?: number;
  minFractionDigits?: number;
  mode?: string;
  prefix?: string;
  suffix?: string;
  showButtons?: boolean;
  showClear?: boolean;
}

export interface NumberFieldConfig extends FormlyFieldConfig<NumberProps> {
  type?: 'number' | Type<NumberTypeComponent>;
}

@Component({
  selector: 'lib-formly-number-type',
  templateUrl: './number-type.component.html',
  styleUrl: './number-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslocoDirective,
    NgClass,
    InputGroup,
    InputGroupAddon,
    InputNumber,
    FormlyModule,
    ReactiveFormsModule
  ]
})
export class NumberTypeComponent extends FieldType<FieldTypeConfig<NumberProps>> {}
